"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var NRG_svg_1 = __importDefault(require("../assets/NRG.svg"));

var AAVE_svg_1 = __importDefault(require("../assets/AAVE.svg"));

var ADA_svg_1 = __importDefault(require("../assets/ADA.svg"));

var AION_svg_1 = __importDefault(require("../assets/AION.svg"));

var AKRO_svg_1 = __importDefault(require("../assets/AKRO.svg"));

var ALGO_svg_1 = __importDefault(require("../assets/ALGO.svg"));

var ALPHA_svg_1 = __importDefault(require("../assets/ALPHA.svg"));

var AMP_svg_1 = __importDefault(require("../assets/AMP.svg"));

var AMPL_svg_1 = __importDefault(require("../assets/AMPL.svg"));

var ANKR_svg_1 = __importDefault(require("../assets/ANKR.svg"));

var ANT_svg_1 = __importDefault(require("../assets/ANT.svg"));

var ARDR_svg_1 = __importDefault(require("../assets/ARDR.svg"));

var ARK_svg_1 = __importDefault(require("../assets/ARK.svg"));

var AR_svg_1 = __importDefault(require("../assets/AR.svg"));

var ATOM_svg_1 = __importDefault(require("../assets/ATOM.svg"));

var AUDIO_svg_1 = __importDefault(require("../assets/AUDIO.svg"));

var AVA_svg_1 = __importDefault(require("../assets/AVA.svg"));

var AVAX_svg_1 = __importDefault(require("../assets/AVAX.svg"));

var AXS_svg_1 = __importDefault(require("../assets/AXS.svg"));

var BADGER_svg_1 = __importDefault(require("../assets/BADGER.svg"));

var BAL_svg_1 = __importDefault(require("../assets/BAL.svg"));

var BAND_svg_1 = __importDefault(require("../assets/BAND.svg"));

var BAO_svg_1 = __importDefault(require("../assets/BAO.svg"));

var BAT_svg_1 = __importDefault(require("../assets/BAT.svg"));

var BCH_svg_1 = __importDefault(require("../assets/BCH.svg"));

var BNB_svg_1 = __importDefault(require("../assets/BNB.svg"));

var BNT_svg_1 = __importDefault(require("../assets/BNT.svg"));

var BLZ_svg_1 = __importDefault(require("../assets/BLZ.svg"));

var BTC_svg_1 = __importDefault(require("../assets/BTC.svg"));

var BSV_svg_1 = __importDefault(require("../assets/BSV.svg"));

var BTS_svg_1 = __importDefault(require("../assets/BTS.svg"));

var BTT_svg_1 = __importDefault(require("../assets/BTT.svg"));

var BZRX_svg_1 = __importDefault(require("../assets/BZRX.svg"));

var CAKE_svg_1 = __importDefault(require("../assets/CAKE.svg"));

var CEL_svg_1 = __importDefault(require("../assets/CEL.svg"));

var CELO_svg_1 = __importDefault(require("../assets/CELO.svg"));

var CELR_svg_1 = __importDefault(require("../assets/CELR.svg"));

var CHSB_svg_1 = __importDefault(require("../assets/CHSB.svg"));

var CHZ_svg_1 = __importDefault(require("../assets/CHZ.svg"));

var CKB_svg_1 = __importDefault(require("../assets/CKB.svg"));

var COMP_svg_1 = __importDefault(require("../assets/COMP.svg"));

var COTI_svg_1 = __importDefault(require("../assets/COTI.svg"));

var CREAM_svg_1 = __importDefault(require("../assets/CREAM.svg"));

var CRV_svg_1 = __importDefault(require("../assets/CRV.svg"));

var CTK_svg_1 = __importDefault(require("../assets/CTK.svg"));

var CVC_svg_1 = __importDefault(require("../assets/CVC.svg"));

var DAI_svg_1 = __importDefault(require("../assets/DAI.svg"));

var DASH_svg_1 = __importDefault(require("../assets/DASH.svg"));

var DCR_svg_1 = __importDefault(require("../assets/DCR.svg"));

var DF_svg_1 = __importDefault(require("../assets/DF.svg"));

var DGB_svg_1 = __importDefault(require("../assets/DGB.svg"));

var DNT_svg_1 = __importDefault(require("../assets/DNT.svg"));

var DODO_svg_1 = __importDefault(require("../assets/DODO.svg"));

var DOGE_svg_1 = __importDefault(require("../assets/DOGE.svg"));

var DOT_svg_1 = __importDefault(require("../assets/DOT.svg"));

var DPI_svg_1 = __importDefault(require("../assets/DPI.svg"));

var DUSK_svg_1 = __importDefault(require("../assets/DUSK.svg"));

var EGLD_svg_1 = __importDefault(require("../assets/EGLD.svg"));

var ELON_svg_1 = __importDefault(require("../assets/ELON.svg"));

var ENJ_svg_1 = __importDefault(require("../assets/ENJ.svg"));

var EOS_svg_1 = __importDefault(require("../assets/EOS.svg"));

var ETC_svg_1 = __importDefault(require("../assets/ETC.svg"));

var ETH_svg_1 = __importDefault(require("../assets/ETH.svg"));

var EWT_svg_1 = __importDefault(require("../assets/EWT.svg"));

var FARM_svg_1 = __importDefault(require("../assets/FARM.svg"));

var FIL_svg_1 = __importDefault(require("../assets/FIL.svg"));

var FRM_svg_1 = __importDefault(require("../assets/FRM.svg"));

var FTM_svg_1 = __importDefault(require("../assets/FTM.svg"));

var FTT_svg_1 = __importDefault(require("../assets/FTT.svg"));

var FUN_svg_1 = __importDefault(require("../assets/FUN.svg"));

var GHST_svg_1 = __importDefault(require("../assets/GHST.svg"));

var GLM_svg_1 = __importDefault(require("../assets/GLM.svg"));

var GNO_svg_1 = __importDefault(require("../assets/GNO.svg"));

var GRT_svg_1 = __importDefault(require("../assets/GRT.svg"));

var HARD_svg_1 = __importDefault(require("../assets/HARD.svg"));

var HBAR_svg_1 = __importDefault(require("../assets/HBAR.svg"));

var HEGIC_svg_1 = __importDefault(require("../assets/HEGIC.svg"));

var HIVE_svg_1 = __importDefault(require("../assets/HIVE.svg"));

var HOT_svg_1 = __importDefault(require("../assets/HOT.svg"));

var HNT_svg_1 = __importDefault(require("../assets/HNT.svg"));

var HT_svg_1 = __importDefault(require("../assets/HT.svg"));

var HXRO_svg_1 = __importDefault(require("../assets/HXRO.svg"));

var ICX_svg_1 = __importDefault(require("../assets/ICX.svg"));

var ILV_svg_1 = __importDefault(require("../assets/ILV.svg"));

var INJ_svg_1 = __importDefault(require("../assets/INJ.svg"));

var IOST_svg_1 = __importDefault(require("../assets/IOST.svg"));

var IOTX_svg_1 = __importDefault(require("../assets/IOTX.svg"));

var KAVA_svg_1 = __importDefault(require("../assets/KAVA.svg"));

var KEEP_svg_1 = __importDefault(require("../assets/KEEP.svg"));

var KMD_svg_1 = __importDefault(require("../assets/KMD.svg"));

var KNC_svg_1 = __importDefault(require("../assets/KNC.svg"));

var KP3R_svg_1 = __importDefault(require("../assets/KP3R.svg"));

var KSM_svg_1 = __importDefault(require("../assets/KSM.svg"));

var LEO_svg_1 = __importDefault(require("../assets/LEO.svg"));

var LINK_svg_1 = __importDefault(require("../assets/LINK.svg"));

var LOOM_svg_1 = __importDefault(require("../assets/LOOM.svg"));

var LRC_svg_1 = __importDefault(require("../assets/LRC.svg"));

var LSK_svg_1 = __importDefault(require("../assets/LSK.svg"));

var LTC_svg_1 = __importDefault(require("../assets/LTC.svg"));

var MANA_svg_1 = __importDefault(require("../assets/MANA.svg"));

var MAPS_svg_1 = __importDefault(require("../assets/MAPS.svg"));

var MASK_svg_1 = __importDefault(require("../assets/MASK.svg"));

var MATIC_svg_1 = __importDefault(require("../assets/MATIC.svg"));

var MFT_svg_1 = __importDefault(require("../assets/MFT.svg"));

var MIOTA_svg_1 = __importDefault(require("../assets/MIOTA.svg"));

var MIR_svg_1 = __importDefault(require("../assets/MIR.svg"));

var MKR_svg_1 = __importDefault(require("../assets/MKR.svg"));

var MTL_svg_1 = __importDefault(require("../assets/MTL.svg"));

var NANO_svg_1 = __importDefault(require("../assets/NANO.svg"));

var NEAR_svg_1 = __importDefault(require("../assets/NEAR.svg"));

var NEO_svg_1 = __importDefault(require("../assets/NEO.svg"));

var NEXO_svg_1 = __importDefault(require("../assets/NEXO.svg"));

var NMR_svg_1 = __importDefault(require("../assets/NMR.svg"));

var NPXS_svg_1 = __importDefault(require("../assets/NPXS.svg"));

var NU_svg_1 = __importDefault(require("../assets/NU.svg"));

var NXM_svg_1 = __importDefault(require("../assets/NXM.svg"));

var NXS_svg_1 = __importDefault(require("../assets/NXS.svg"));

var RUNE_svg_1 = __importDefault(require("../assets/RUNE.svg"));

var LUNA_svg_1 = __importDefault(require("../assets/LUNA.svg"));

var OCEAN_svg_1 = __importDefault(require("../assets/OCEAN.svg"));

var OGN_svg_1 = __importDefault(require("../assets/OGN.svg"));

var OMI_svg_1 = __importDefault(require("../assets/OMI.svg"));

var _1INCH_svg_1 = __importDefault(require("../assets/1INCH.svg"));

var ONE_svg_1 = __importDefault(require("../assets/ONE.svg"));

var OMG_svg_1 = __importDefault(require("../assets/OMG.svg"));

var ONT_svg_1 = __importDefault(require("../assets/ONT.svg"));

var ORN_svg_1 = __importDefault(require("../assets/ORN.svg"));

var PAXG_svg_1 = __importDefault(require("../assets/PAXG.svg"));

var PERP_svg_1 = __importDefault(require("../assets/PERP.svg"));

var POLS_svg_1 = __importDefault(require("../assets/POLS.svg"));

var POLY_svg_1 = __importDefault(require("../assets/POLY.svg"));

var POWR_svg_1 = __importDefault(require("../assets/POWR.svg"));

var PPT_svg_1 = __importDefault(require("../assets/PPT.svg"));

var PREMIA_svg_1 = __importDefault(require("../assets/PREMIA.svg"));

var QKC_svg_1 = __importDefault(require("../assets/QKC.svg"));

var QNT_svg_1 = __importDefault(require("../assets/QNT.svg"));

var QTUM_svg_1 = __importDefault(require("../assets/QTUM.svg"));

var RARI_svg_1 = __importDefault(require("../assets/RARI.svg"));

var REEF_svg_1 = __importDefault(require("../assets/REEF.svg"));

var REN_svg_1 = __importDefault(require("../assets/REN.svg"));

var REP_svg_1 = __importDefault(require("../assets/REP.svg"));

var RFOX_svg_1 = __importDefault(require("../assets/RFOX.svg"));

var RGT_svg_1 = __importDefault(require("../assets/RGT.svg"));

var RIF_svg_1 = __importDefault(require("../assets/RIF.svg"));

var RLC_svg_1 = __importDefault(require("../assets/RLC.svg"));

var ROOK_svg_1 = __importDefault(require("../assets/ROOK.svg"));

var ROSE_svg_1 = __importDefault(require("../assets/ROSE.svg"));

var RSR_svg_1 = __importDefault(require("../assets/RSR.svg"));

var RVN_svg_1 = __importDefault(require("../assets/RVN.svg"));

var SAND_svg_1 = __importDefault(require("../assets/SAND.svg"));

var SC_svg_1 = __importDefault(require("../assets/SC.svg"));

var SCRT_svg_1 = __importDefault(require("../assets/SCRT.svg"));

var SFI_svg_1 = __importDefault(require("../assets/SFI.svg"));

var SFP_svg_1 = __importDefault(require("../assets/SFP.svg"));

var SHIB_svg_1 = __importDefault(require("../assets/SHIB.svg"));

var SLP_svg_1 = __importDefault(require("../assets/SLP.svg"));

var SNT_svg_1 = __importDefault(require("../assets/SNT.svg"));

var SNX_svg_1 = __importDefault(require("../assets/SNX.svg"));

var SOL_svg_1 = __importDefault(require("../assets/SOL.svg"));

var SPELL_svg_1 = __importDefault(require("../assets/SPELL.svg"));

var SRM_svg_1 = __importDefault(require("../assets/SRM.svg"));

var STAKE_svg_1 = __importDefault(require("../assets/STAKE.svg"));

var STEEM_svg_1 = __importDefault(require("../assets/STEEM.svg"));

var STORJ_svg_1 = __importDefault(require("../assets/STORJ.svg"));

var STX_svg_1 = __importDefault(require("../assets/STX.svg"));

var SUPER_svg_1 = __importDefault(require("../assets/SUPER.svg"));

var SUSHI_svg_1 = __importDefault(require("../assets/SUSHI.svg"));

var SWAP_svg_1 = __importDefault(require("../assets/SWAP.svg"));

var SYS_svg_1 = __importDefault(require("../assets/SYS.svg"));

var THETA_svg_1 = __importDefault(require("../assets/THETA.svg"));

var TOMO_svg_1 = __importDefault(require("../assets/TOMO.svg"));

var TRB_svg_1 = __importDefault(require("../assets/TRB.svg"));

var TRX_svg_1 = __importDefault(require("../assets/TRX.svg"));

var TWT_svg_1 = __importDefault(require("../assets/TWT.svg"));

var UBT_svg_1 = __importDefault(require("../assets/UBT.svg"));

var UMA_svg_1 = __importDefault(require("../assets/UMA.svg"));

var UNI_svg_1 = __importDefault(require("../assets/UNI.svg"));

var USDC_svg_1 = __importDefault(require("../assets/USDC.svg"));

var VET_svg_1 = __importDefault(require("../assets/VET.svg"));

var VGX_svg_1 = __importDefault(require("../assets/VGX.svg"));

var WAN_svg_1 = __importDefault(require("../assets/WAN.svg"));

var WAVES_svg_1 = __importDefault(require("../assets/WAVES.svg"));

var WRX_svg_1 = __importDefault(require("../assets/WRX.svg"));

var XEM_svg_1 = __importDefault(require("../assets/XEM.svg"));

var XLM_svg_1 = __importDefault(require("../assets/XLM.svg"));

var XMR_svg_1 = __importDefault(require("../assets/XMR.svg"));

var XRP_svg_1 = __importDefault(require("../assets/XRP.svg"));

var XTZ_svg_1 = __importDefault(require("../assets/XTZ.svg"));

var YFI_svg_1 = __importDefault(require("../assets/YFI.svg"));

var YFII_svg_1 = __importDefault(require("../assets/YFII.svg"));

var ZEC_svg_1 = __importDefault(require("../assets/ZEC.svg"));

var ZEN_svg_1 = __importDefault(require("../assets/ZEN.svg"));

var ZIL_svg_1 = __importDefault(require("../assets/ZIL.svg"));

var ZKS_svg_1 = __importDefault(require("../assets/ZKS.svg"));

var ZRX_svg_1 = __importDefault(require("../assets/ZRX.svg"));

var USDE_svg_1 = __importDefault(require("../assets/USDE.svg"));

var CRO_svg_1 = __importDefault(require("../assets/CRO.svg"));

var MDX_svg_1 = __importDefault(require("../assets/MDX.svg"));

var OKB_svg_1 = __importDefault(require("../assets/OKB.svg"));

exports["default"] = {
  WNRGLogo: NRG_svg_1["default"],
  AAVELogo: AAVE_svg_1["default"],
  ADALogo: ADA_svg_1["default"],
  AIONLogo: AION_svg_1["default"],
  AKROLogo: AKRO_svg_1["default"],
  ALGOLogo: ALGO_svg_1["default"],
  ALPHALogo: ALPHA_svg_1["default"],
  AMPLogo: AMP_svg_1["default"],
  AMPLLogo: AMPL_svg_1["default"],
  ANKRLogo: ANKR_svg_1["default"],
  ANTLogo: ANT_svg_1["default"],
  ARDRLogo: ARDR_svg_1["default"],
  ARKLogo: ARK_svg_1["default"],
  ARLogo: AR_svg_1["default"],
  ATOMLogo: ATOM_svg_1["default"],
  AUDIOLogo: AUDIO_svg_1["default"],
  AVALogo: AVA_svg_1["default"],
  AVAXLogo: AVAX_svg_1["default"],
  AXSLogo: AXS_svg_1["default"],
  BADGERLogo: BADGER_svg_1["default"],
  BALLogo: BAL_svg_1["default"],
  BANDLogo: BAND_svg_1["default"],
  BAOLogo: BAO_svg_1["default"],
  BATLogo: BAT_svg_1["default"],
  BCHLogo: BCH_svg_1["default"],
  BNBLogo: BNB_svg_1["default"],
  BNTLogo: BNT_svg_1["default"],
  BLZLogo: BLZ_svg_1["default"],
  BTCLogo: BTC_svg_1["default"],
  BSVLogo: BSV_svg_1["default"],
  BTSLogo: BTS_svg_1["default"],
  BTTLogo: BTT_svg_1["default"],
  BZRXLogo: BZRX_svg_1["default"],
  CAKELogo: CAKE_svg_1["default"],
  CELLogo: CEL_svg_1["default"],
  CELOLogo: CELO_svg_1["default"],
  CELRLogo: CELR_svg_1["default"],
  CHSBLogo: CHSB_svg_1["default"],
  CHZLogo: CHZ_svg_1["default"],
  CKBLogo: CKB_svg_1["default"],
  COMPLogo: COMP_svg_1["default"],
  COTILogo: COTI_svg_1["default"],
  CREAMLogo: CREAM_svg_1["default"],
  CRVLogo: CRV_svg_1["default"],
  CTKLogo: CTK_svg_1["default"],
  CVCLogo: CVC_svg_1["default"],
  DAILogo: DAI_svg_1["default"],
  DASHLogo: DASH_svg_1["default"],
  DCRLogo: DCR_svg_1["default"],
  DFLogo: DF_svg_1["default"],
  DGBLogo: DGB_svg_1["default"],
  DNTLogo: DNT_svg_1["default"],
  DODOLogo: DODO_svg_1["default"],
  DOGELogo: DOGE_svg_1["default"],
  DOTLogo: DOT_svg_1["default"],
  DPILogo: DPI_svg_1["default"],
  DUSKLogo: DUSK_svg_1["default"],
  EGLDLogo: EGLD_svg_1["default"],
  ELONLogo: ELON_svg_1["default"],
  ENJLogo: ENJ_svg_1["default"],
  EOSLogo: EOS_svg_1["default"],
  ETCLogo: ETC_svg_1["default"],
  ETHLogo: ETH_svg_1["default"],
  EWTLogo: EWT_svg_1["default"],
  FARMLogo: FARM_svg_1["default"],
  FILLogo: FIL_svg_1["default"],
  FRMLogo: FRM_svg_1["default"],
  FTMLogo: FTM_svg_1["default"],
  FTTLogo: FTT_svg_1["default"],
  FUNLogo: FUN_svg_1["default"],
  GHSTLogo: GHST_svg_1["default"],
  GLMLogo: GLM_svg_1["default"],
  GNOLogo: GNO_svg_1["default"],
  GRTLogo: GRT_svg_1["default"],
  HARDLogo: HARD_svg_1["default"],
  HBARLogo: HBAR_svg_1["default"],
  HEGICLogo: HEGIC_svg_1["default"],
  HIVELogo: HIVE_svg_1["default"],
  HOTLogo: HOT_svg_1["default"],
  HNTLogo: HNT_svg_1["default"],
  HTLogo: HT_svg_1["default"],
  HXROLogo: HXRO_svg_1["default"],
  ICXLogo: ICX_svg_1["default"],
  ILVLogo: ILV_svg_1["default"],
  INJLogo: INJ_svg_1["default"],
  IOSTLogo: IOST_svg_1["default"],
  IOTXLogo: IOTX_svg_1["default"],
  KAVALogo: KAVA_svg_1["default"],
  KEEPLogo: KEEP_svg_1["default"],
  KMDLogo: KMD_svg_1["default"],
  KNCLogo: KNC_svg_1["default"],
  KP3RLogo: KP3R_svg_1["default"],
  KSMLogo: KSM_svg_1["default"],
  LEOLogo: LEO_svg_1["default"],
  LINKLogo: LINK_svg_1["default"],
  LOOMLogo: LOOM_svg_1["default"],
  LRCLogo: LRC_svg_1["default"],
  LSKLogo: LSK_svg_1["default"],
  LTCLogo: LTC_svg_1["default"],
  MANALogo: MANA_svg_1["default"],
  MAPSLogo: MAPS_svg_1["default"],
  MASKLogo: MASK_svg_1["default"],
  MATICLogo: MATIC_svg_1["default"],
  MFTLogo: MFT_svg_1["default"],
  MIOTALogo: MIOTA_svg_1["default"],
  MIRLogo: MIR_svg_1["default"],
  MKRLogo: MKR_svg_1["default"],
  MTLLogo: MTL_svg_1["default"],
  NANOLogo: NANO_svg_1["default"],
  NEARLogo: NEAR_svg_1["default"],
  NEOLogo: NEO_svg_1["default"],
  NEXOLogo: NEXO_svg_1["default"],
  NMRLogo: NMR_svg_1["default"],
  NPXSLogo: NPXS_svg_1["default"],
  NULogo: NU_svg_1["default"],
  NXMLogo: NXM_svg_1["default"],
  NXSLogo: NXS_svg_1["default"],
  RUNELogo: RUNE_svg_1["default"],
  LUNALogo: LUNA_svg_1["default"],
  OCEANLogo: OCEAN_svg_1["default"],
  OGNLogo: OGN_svg_1["default"],
  OMILogo: OMI_svg_1["default"],
  ONEINCHLogo: _1INCH_svg_1["default"],
  ONELogo: ONE_svg_1["default"],
  OMGLogo: OMG_svg_1["default"],
  ONTLogo: ONT_svg_1["default"],
  ORNLogo: ORN_svg_1["default"],
  PAXGLogo: PAXG_svg_1["default"],
  PERPLogo: PERP_svg_1["default"],
  POLSLogo: POLS_svg_1["default"],
  POLYLogo: POLY_svg_1["default"],
  POWRLogo: POWR_svg_1["default"],
  PPTLogo: PPT_svg_1["default"],
  PREMIALogo: PREMIA_svg_1["default"],
  QKCLogo: QKC_svg_1["default"],
  QNTLogo: QNT_svg_1["default"],
  QTUMLogo: QTUM_svg_1["default"],
  RARILogo: RARI_svg_1["default"],
  REEFLogo: REEF_svg_1["default"],
  RENLogo: REN_svg_1["default"],
  REPLogo: REP_svg_1["default"],
  RFOXLogo: RFOX_svg_1["default"],
  RGTLogo: RGT_svg_1["default"],
  RIFLogo: RIF_svg_1["default"],
  RLCLogo: RLC_svg_1["default"],
  ROOKLogo: ROOK_svg_1["default"],
  ROSELogo: ROSE_svg_1["default"],
  RSRLogo: RSR_svg_1["default"],
  RVNLogo: RVN_svg_1["default"],
  SANDLogo: SAND_svg_1["default"],
  SCLogo: SC_svg_1["default"],
  SCRTLogo: SCRT_svg_1["default"],
  SFILogo: SFI_svg_1["default"],
  SFPLogo: SFP_svg_1["default"],
  SHIBLogo: SHIB_svg_1["default"],
  SLPLogo: SLP_svg_1["default"],
  SNTLogo: SNT_svg_1["default"],
  SNXLogo: SNX_svg_1["default"],
  SOLLogo: SOL_svg_1["default"],
  SPELLLogo: SPELL_svg_1["default"],
  SRMLogo: SRM_svg_1["default"],
  STAKELogo: STAKE_svg_1["default"],
  STEEMLogo: STEEM_svg_1["default"],
  STORJLogo: STORJ_svg_1["default"],
  STXLogo: STX_svg_1["default"],
  SUPERLogo: SUPER_svg_1["default"],
  SUSHILogo: SUSHI_svg_1["default"],
  SWAPLogo: SWAP_svg_1["default"],
  SYSLogo: SYS_svg_1["default"],
  THETALogo: THETA_svg_1["default"],
  TOMOLogo: TOMO_svg_1["default"],
  TRBLogo: TRB_svg_1["default"],
  TRXLogo: TRX_svg_1["default"],
  TWTLogo: TWT_svg_1["default"],
  UBTLogo: UBT_svg_1["default"],
  UMALogo: UMA_svg_1["default"],
  UNILogo: UNI_svg_1["default"],
  USDCLogo: USDC_svg_1["default"],
  VETLogo: VET_svg_1["default"],
  VGXLogo: VGX_svg_1["default"],
  WANLogo: WAN_svg_1["default"],
  WAVESLogo: WAVES_svg_1["default"],
  WRXLogo: WRX_svg_1["default"],
  XEMLogo: XEM_svg_1["default"],
  XLMLogo: XLM_svg_1["default"],
  XMRLogo: XMR_svg_1["default"],
  XRPLogo: XRP_svg_1["default"],
  XTZLogo: XTZ_svg_1["default"],
  YFILogo: YFI_svg_1["default"],
  YFIILogo: YFII_svg_1["default"],
  ZECLogo: ZEC_svg_1["default"],
  ZENLogo: ZEN_svg_1["default"],
  ZILLogo: ZIL_svg_1["default"],
  ZKSLogo: ZKS_svg_1["default"],
  ZRXLogo: ZRX_svg_1["default"],
  USDELogo: USDE_svg_1["default"],
  CROLogo: CRO_svg_1["default"],
  MDXLogo: MDX_svg_1["default"],
  OKBLogo: OKB_svg_1["default"]
};